<template>
<div class="month-select">
    <i class="sm-arrow-left float ileft" 
        :class="{disabled: !canPrev}"
        @click="prev" 
        :disabled="!canPrev"
        @touchstart="prev"></i>
    <i class="sm-arrow-right float iright" 
        :class="{disabled: !canNext}"
        @click="next" 
        :disabled="!canNext"
        @touchstart="next"></i>
    <div class="text center">
        <input type="number" v-model="year" 
            :value="year" @change="changeYear()" 
            :min="minYear"
            :max="maxYear"
            class="year-input">
         / 
        <input type="number" v-model="showMonth" 
            :value="showMonth" @change="changeMonth()"
            @click="showMonthPicker"
            min="1" max="12"
            class="month-input">
    </div>
    <month-picker 
        :params="{value: showMonth}"
        @value-change="selectMonth"
        v-if="view=='month'"></month-picker>
</div>
</template>


<script type="text/javascript">
import Moment from 'moment'
import ui from '../base/ui'
import MonthPicker from './MonthPicker'

// 生成12月份数组
const monthArray = new Array(12)

for (let idx = 0; idx < monthArray.length; idx++) {
    monthArray[idx] = idx < 9 ? '0' + (idx + 1) : '' + (idx + 1)
}

const params = {
    view: 'month',
    canPrev: true,
    canNext: true,
    year: 2016,
    month: 0,
    showMonth: 1
}

export default {
    mixins: [ui],
    params: params,
    computed: {
        maxYear () {
            return new Date().getFullYear()
        },
        minYear () {
            return new Moment().add(-2, 'year').year()
        }
    },
    methods: {
        render () {
            this.emit(
                'month-change', 
                {
                    year: +this.year,
                    showMonth: +this.showMonth,
                    month: +this.month
                }
            )
        },
        changeYear () {
            if (this.year < 1970 || this.year > 2500) {
                this.year = new Moment(this.value).year()
            }
            this.render()
        },
        changeMonth () {
            if (this.showMonth < 1 || this.showMonth > 12) {
                this.showMonth = new Moment(this.value).month() + 1
            }
            this.month = this.showMonth - 1;
            this.render()
        },
        prev (e) {
            e.stopPropagation()
            var time = new Moment(
                new Date(this.year, this.month, 1)).subtract(1, 'month')
            this.year = time.year()
            this.month = time.month()
            this.render()
        },
        next (e) {
            e.stopPropagation()
            var time = new Moment(
                new Date(this.year, this.month, 1)).add(1, 'month')
            this.year = time.year()
            this.month = time.month()
            this.render()
        },
        showMonthPicker () {
            this.view = 'month'
        },
        selectMonth (e) {
            this.month = e.data.value - 1
            this.showMonth = e.data.value
            this.view = 'dates'
            this.render()
        }
    },
    components: {
        MonthPicker
    }
}
</script>

<style type="text/css" lang="less">

.month-select {
    height:32px;
    max-width: 280px;
    font-size: 18px;
    line-height: 32px;
    color:#42b983;

    .float.ileft{
        float:left;
        font-size: 16px;
    }
    .float.iright{
        float:right;
        font-size: 16px;
    }
    input {
        font-size: 18px;
        line-height: 32px;
        color: #42b983;
        width: 60px;
        text-align: center;
        border:none;
        background-color: transparent;
    }
    &>i{
        margin:0 12px;
        line-height: 32px;
        cursor: pointer;
        color:#707070;
    }
    &>i:hover{
        color:#42b983;
    }  
    .disabled {
        color: #EEE;
    }
}


</style>


// WEBPACK FOOTER //
// MonthSelect.vue?0ac703af